<template>
    <div style="height:100%;overflow-y:auto">
        <head-search style="position:fixed;top:0;left:0;z-index:99;right:0;background:#fff"></head-search>
        <div class="mainBox">
            <div class="parentBox">
                <li class="searchItem" v-for="(item,i) in list" :key="i">
                    <div class="leftIcon" ><i class="iconfont fileIcon" >&#xe62e;</i></div>
                    <div class="itemMes">{{item.name}}</div>
                    <div class="rightIcon"><i class="iconfont">></i></div>
                </li>
            </div>
            <div class="null"></div>
            <div class="childBox">
                <div class="searchItem" v-for="(item,i) in fileList1" :key="i">
                    <div class="leftIcon" :class="item.type==1?'leftIcon1':item.type==2?'leftIcon2':item.type==3?'leftIcon3':'leftIcon4'"><i class="iconfont currentIcon" v-html="item.icon"></i></div>
                    <div class="itemMes">{{item.name}}</div>
                    <div class="rightIcon"><i class="iconfont">></i></div>
                </div>
            </div>
            <div class="noMore">没有更多了</div>
        </div>
    </div>
</template>
<script>
import { defineComponent, reactive, toRefs } from 'vue'
import headSearch from '../common/mobileSearch.vue'
export default defineComponent({
    components:{headSearch},
    setup() {
        const state=reactive({
            list:[
                {
                  name:'二级1'
                },{
                   name:'二级2-二级2-二级2-二级2-二级2-二级2-二级2-二级2-二级2' 
                }
            ],
            fileList1:[
                {
                    name:'查看产品介绍',
                    type:1,
                    icon:'&#xe60d;'
                },
                {
                    name:'易鲸云词汇释义',
                    type:2,
                    icon:'&#xe7ba;'
                },
                {
                    name:'产品中心',
                    type:3,
                    icon:'&#xe6b8;'
                },
                {
                    name:'产品中心产品中心产品中心产品中心产品中心产品中心品中心产品中心',
                    type:4,
                    icon:'&#xe693;'
                }
            ]
        })
        return {
            ...toRefs(state)
        }
    },
})
</script>
<style lang="scss" scoped>
.mainBox{
    margin-top: 92px;
    .parentBox{
         padding: 0 16px;
        box-sizing: border-box;
        .searchItem{
            height: 64px;
            width: 100%;
            border-top: 1px solid#E0E6EF;
            display: flex;
            align-items: center;
        }
        .searchItem:nth-of-type(1){
            border-top: none;
        }
    }
    .null{
        height: 18px;
        background: rgb(247, 247, 247);
    }
    .childBox{
        padding: 0 16px;
        box-sizing: border-box;
       .searchItem{
            height: 64px;
            width: 100%;
            border-top: 1px solid#E0E6EF;
            display: flex;
            align-items: center;
        }
        .searchItem:nth-of-type(1){
            border-top: none;
        } 
    }
    .noMore{
        width: 100%;
        text-align: center;
        height: 18px;
        line-height: 18px;
        font-size: 13px;
        color: #999999;
        letter-spacing: 0;
        font-weight: 400;
        margin-top: 18px;
        margin-bottom: 50px;
    }
    .searchItem{
        .leftIcon{
            width: 32px;
            height: 32px;
            border-radius: 50%;
            background: rgba(255,148,34,0.10);
            margin-right: 10px;
            text-align: center;
            line-height: 32px;
            .currentIcon,.fileIcon{
                font-size: 18px;
                color: #fd801b;
            }
            .fileIcon{
                font-size: 20px;
            }
        }
        .itemMes{
            flex: 1;
            padding-right: 4px;
            box-sizing: border-box;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 14px;
            color: #333333;
            letter-spacing: 0;
            font-weight: 400;
        }
        .rightIcon{
            color: #999999;
            font-size: 18px;
        }
        .leftIcon1{
            background: #d5dff8;
            .currentIcon{
               color: #2A61EC; 
               font-size: 17px;
            }
        }
        .leftIcon2{
            background: #f7e3cf;
            .currentIcon{
               color: #FF9422; 
               font-size: 19px;
            }
        }
        .leftIcon3{
            background: #fae0e0;
            .currentIcon{
               color: #E02020; 
               opacity: 1;
            }
        }
        .leftIcon4{
            background: #dbfaf8;
            .currentIcon{
               color: #00B2A8; 
            }
        }
    }
    
    .itemIcon{
        color: #999999;
        font-size: 20px;
    }
}
    
</style>

